import { render } from "./specialServiceNumber.vue?vue&type=template&id=2559babe&scoped=true"
import script from "./specialServiceNumber.vue?vue&type=script&lang=js"
export * from "./specialServiceNumber.vue?vue&type=script&lang=js"

import "./specialServiceNumber.vue?vue&type=style&index=0&id=2559babe&scoped=true&lang=css"
import "./specialServiceNumber.vue?vue&type=style&index=1&id=2559babe&lang=css"
script.render = render
script.__scopeId = "data-v-2559babe"

export default script